/**
 * OpenAPI definition
 *
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * Order correction against House LP
 */
export interface OrderCorrectionRequestDto {
  /**
   * Order ID
   */
  orderId: number;
  /**
   * New quantity. If zero - trade will be just cancelled
   */
  quantity: number;
  /**
   * New client price.
   */
  price: number;
  /**
   * New client total.
   */
  total: number;
}
